export default "__VITE_ASSET__BBLrM3Nh__"